<template>
  <section id="" class="section-scc-portal">
    <div class="container">
      <h1>Rewards</h1>
      <div id="wpgv-giftitems-step1" class="wpgv-items-wrap row">
        <div class="col-xl-4 col-12">
          <div class="wpgv-according-categories-title">
            You current balance: {{ freePoints }} Points
          </div>
          <div class="wpgv-according-categories">
            <div class="filter_rewards_category">
              <span class="filterTitle">Categories</span>
              <ul _ngcontent-c53="" class="checkbox-filter_list list-group">
                <li
                    class="checkbox-filter_item list-group-item"
                    v-for="(itemCategory, keyCategory) in rewardCategory" :key="keyCategory"
                >
                  <a class="checkbox-filter_link" href="javascript:$(&#39;input0 Points#&#39;).toggle();">
                    <input
                        class="custom-checkbox"
                        type="checkbox"
                        :id="'check-' + keyCategory"
                        v-model="itemCategory.value"
                        v-on:change="changeTest()"
                    >
                    <label class="check-category" :for="'check-' + keyCategory">
                      {{itemCategory.label}}&nbsp;
                      <span class="sidebar-block__quantity"> ({{ itemCategory.quantityRewards }}) </span>
                    </label>
                  </a>
                </li>
<!--
                <li class="checkbox-filter_item list-group-item">
                  <a class="checkbox-filter_link" href="javascript:$(&#39;input100 – 200 Points#&#39;).toggle();">
                    <input data-cat-id="15" class="custom-checkbox" type="checkbox" id="rewcat_15">&nbsp;<label style="cursor:pointer;" for="rewcat_15">100 – 200 Points&nbsp;<span class="sidebar-block__quantity"> (4) </span></label>
                  </a>
                </li>
-->
              </ul>
            </div>
          </div>
        </div>
        <!-- main content -->
        <div class="col-xl-8 col-12">
          <div class="wpgv-items row">
            <div class="wpgv-item col-md-6 col-12"
                 v-for="(itemRewards, keyRewards) in rewards" :key="keyRewards"
            >
                <div class="wpgv-thumnb">
                  <img class="wpgv-thumnb-image" :src="itemRewards.url">
                </div>
                <div class="wpgv-content">
                  <h4>{{ itemRewards.name }}{{ keyRewards }}</h4>
                </div>
                <div class="wpgv-buy-div">
                  <button
                      class="button-section btn center"
                      type="button"
                      @click="actionChoiceRewards(itemRewards)"
                  >
                    <span>{{ itemRewards.points + ' POINTS'}} </span>
                  </button>
 <!--               </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/*import {mapState} from "vuex";*/
export default {
  name: "rewardsStore",
  data(){
    return {
      rewards: [],
      freePoints: '',
      url: require('../../../assets/rewards/rewards_image_' + 1 + '.png'),
      rewardCategory: {
        0: {
          name: '0',
          label: '0 Points',
          value: true,
          quantityRewards: '',
        },
        100: {
          name: '100',
          label: '0-100 Points',
          value: true,
          quantityRewards: '',
        },
        200: {
          name: '200',
          label: '100-200 Points',
          value: true,
          quantityRewards: '',
        },
      }
    }
  },
  computed : {/*
    ...mapState({
      rewardsStore: state => state.rewards.rewards,
    })
*/
  },
  async mounted() {
    let rw =this
    this.rewards = await this.$store.dispatch('rewards/SET_getAllRewards')
    this.freePoints = this.$store.getters["donorInformation/pointsTotal"]-this.$store.getters["donorInformation/sumRewardsPoints"]
    this.freePoints = this.freePoints>0?this.freePoints:0
    let counter

    Object.keys(this.rewardCategory).forEach(function(keyCategory){
      counter = 0
      // eslint-disable-next-line no-unused-vars
      rw.rewards.forEach(function(item, index){
        if(item.category === keyCategory){
          counter = counter + 1
        }
      })
      rw.rewardCategory[keyCategory].quantityRewards = counter
    })
    this.rewards.sort( (a, b) => {
      if (Number(a.points)<Number(b.points)){
        return -1
      } else {
        return 1
      }
    })
  },
  methods: {
    actionChoiceRewards(reward){
      this.$store.commit('rewards/set_recordItemRewards', reward)
      this.$store.commit('rewards/set_showPage', { triggerDescriptionOrder: true })
      this.$router.push({ name: 'rwDescriptionOrder' })
    },
    quantityRewardsCategory(){},
    changeTest(){
      let rw = this
      let createRewards = []
      const temRewards = this.$store.getters["rewards/rewards"]
      Object.keys(rw.rewardCategory).forEach((rewardsKey)=>{
        temRewards.forEach( item => {
          if(rw.rewardCategory[rewardsKey].value && Number(item.category) == rewardsKey ){
            createRewards.push(item)
          }
        })
      })
      this.rewards = createRewards
    },
  },
}
</script>
<style>
.button-section.btn.center {
  display: inline-block !important;
}
.wpgv-item .wpgv-buy button {
  padding: 10px 18px;
  border-radius: 5px;
  color: #fff;
  background: #c9c76d;
  line-height: 1;
  cursor: pointer;
  outline: 0;
}
.button-section:hover, .button-section:active {
  color: var(--ButtonTextHover);
  background-color: var(--ButtonColor);
  border-color: var(--ButtonColor);
}
</style>
<style scoped>
  .wpgv-according-categories {
    background: #fafafa;
    border-radius: 0 0 5px 5px;
    padding: 15px 15px 0;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%), 0 3px 1px -2px rgb(0 0 0 / 20%);
    margin-bottom: 30px;
    max-width: 400px;
  }
  .list-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: .25rem;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
  }
  .list-group-item {
    padding: 0;
    background-color: transparent;
    border: none;
  }
  .checkbox-filter_link:hover, .checkbox-filter_link input:hover .checkbox-filter_link label:hover .checkbox-filter_link label span:hover .checkbox-filter_link span:hover, .checkbox-filter_link, .checkbox-filter_link input .checkbox-filter_link label .checkbox-filter_link label span .checkbox-filter_link span {
    cursor: pointer !important;
    text-decoration: unset !important;
  }
  .wpgv-items-wrap label {
    color: #000;
    margin-bottom: 3px;
    font-weight: 600;
    font-size: 15px;
  }
  .wpgv-items-wrap label:not(:first-child) {
    font-weight: normal;
  }
  .wpgv-item {
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
  .wpgv-thumnb {
    height: 200px;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
  }
  .wpgv-items {
    justify-content: space-around;
  }
  .wpgv-item.left {
    float: left;
    width: 390px;
    height: 319px;
  }
  .wpgv-thumnb-image {
    border-radius: 10%;
    width: 100%;
    height: 100%;
    object-fit: fill;
    border: 2px solid #c9c76d;
  }
  .wpgv-item .wpgv-content {
    text-align: center;
  }
  .wpgv-item .wpgv-buy, .wpgv-item .wpgv-buy-div {
    text-align: center;
  }
  .check-category{
    cursor:pointer; margin-left:5px
  }
</style>
